import body from "../../../index.module.scss";
import classes from "./SecondStep.module.scss"
import SectionTitle from '../../Titles/SectionTitle/SectionTitle';
import WorkList from "./WorkList/WorkList";
import Analytics from "./Analytics/Analytics";
import SeoList from './SeoList/SeoList';
import PinkBg from './../../PinkBlock/PinkBlock';

const SecondStep = ()=> {
  return( 
    <section id="Works" className={classes.SecondStep}> 
      <div className={body.container}>
        <PinkBg number={2} customClass={classes.PinkBg} CustomNumClass={classes.CustomNumClass}/>
        <SectionTitle text={<>Выполненные<br/> работы</>} customClass={classes.Title}/>
        <WorkList/>
        <Analytics/>
        <SeoList/>
      </div>
    </section>
  )
}

export default SecondStep;